import * as e from "react";
import { useState as $, useRef as Be, useCallback as re, useEffect as ge, Fragment as Ue } from "react";
const bl = {
  primary: "#1d4ed8",
  primaryBg: "#dbeafe",
  headerBg: "#1f2937",
  text: "#374151",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  surface: "#f3f4f6"
}, Ce = "poc_portal_token", fe = "poc_portal_refresh", xe = "auth:session-expired", Xe = window.location.hostname === "dev.gennolab.co.jp" ? "" : "https://dev.gennolab.co.jp";
let Pe = Xe + "/chat-api/api/auth";
function gl(t) {
  t.authBase && (Pe = t.authBase);
}
function Le(t) {
  try {
    const n = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(n))));
  } catch {
    return {};
  }
}
function Ve(t, n = 30) {
  const a = Le(t).exp;
  return !a || a * 1e3 < Date.now() + n * 1e3;
}
function We(t = 30) {
  const n = localStorage.getItem(fe);
  if (!n) return !0;
  const a = Le(n).exp;
  return !!a && a * 1e3 < Date.now() + t * 1e3;
}
function He() {
  return localStorage.getItem(Ce);
}
function Je(t, n) {
  localStorage.setItem(Ce, t), n && localStorage.setItem(fe, n);
}
function Ze() {
  localStorage.removeItem(Ce), localStorage.removeItem(fe), Oe();
}
function he() {
  Ze(), window.dispatchEvent(new Event(xe));
}
function fl(t) {
  return window.addEventListener(xe, t), () => window.removeEventListener(xe, t);
}
let be = null;
const Ye = 2147483647;
function Qe() {
  if (Oe(), We()) {
    he();
    return;
  }
  const t = localStorage.getItem(fe), n = t ? Le(t).exp : void 0;
  if (!n) return;
  const a = Math.min(Math.max(n * 1e3 - Date.now() - 30 * 1e3, 0), Ye);
  be = setTimeout(() => {
    be = null, Qe();
  }, a);
}
function Oe() {
  be !== null && (clearTimeout(be), be = null);
}
let Ne = null;
function Ge() {
  return Ne || (Ne = et()), Ne;
}
async function et() {
  try {
    return await tt();
  } finally {
    Ne = null;
  }
}
async function tt() {
  const t = localStorage.getItem(fe);
  if (!t)
    return he(), null;
  let n;
  try {
    n = await fetch(Pe + "/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: t })
    });
  } catch {
    return null;
  }
  if (!n.ok)
    return n.status < 500 && he(), null;
  const a = await n.json().catch(() => ({}));
  return a.access_token ? (Je(a.access_token, a.refresh_token), a.access_token) : (he(), null);
}
async function nt() {
  if (We())
    return he(), null;
  const t = He();
  return t && !Ve(t) ? t : Ge();
}
async function ye(t, n = {}) {
  const a = (c) => {
    var l;
    return {
      ...n,
      headers: { ...(l = n.headers) != null ? l : {}, ...c ? { Authorization: "Bearer " + c } : {} }
    };
  }, o = await nt();
  let s = await fetch(t, a(o));
  if (s.status === 401 && o) {
    const c = await Ge();
    c && (s = await fetch(t, a(c)));
  }
  return s;
}
let ce = Xe + "/chat-api/api/comments";
function yl(t) {
  t.base && (ce = t.base);
}
function at(t) {
  return t.parentId !== void 0 && t.parentId !== null;
}
async function Ee(t) {
  var a;
  const n = await t.json().catch(() => ({}));
  if (!t.ok) throw new Error((a = n.error) != null ? a : `요청 실패 (${t.status})`);
  return n;
}
async function Ie(t, n, a, o, s) {
  const c = new URLSearchParams({ targetType: t, targetId: n, page: String(a), size: String(o) }), l = await ye(`${ce}?${c}`, { cache: "no-store", signal: s });
  return Ee(l);
}
async function ot(t, n, a, o) {
  const s = await ye(ce, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ targetType: t, targetId: n, content: a, parentId: o })
  });
  return Ee(s);
}
async function st(t, n) {
  const a = await ye(`${ce}/${t}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content: n })
  });
  return Ee(a);
}
async function ct(t) {
  const n = await ye(`${ce}/${t}`, { method: "DELETE" });
  return (await Ee(n)).status;
}
async function lt(t, n, a) {
  if (n.length === 0) return {};
  const o = new URLSearchParams({ targetType: t, targetIds: n.join(",") }), s = await ye(`${ce}/counts?${o}`, { cache: "no-store", signal: a });
  return (await Ee(s)).counts;
}
const Se = 50;
function je(t) {
  return t.parentId === void 0 || t.parentId === null;
}
function rt(t, n) {
  if (je(n)) return [...t, n];
  const a = n.parentId;
  let o = -1;
  for (let s = 0; s < t.length; s += 1)
    (t[s].id === a || t[s].parentId === a) && (o = s);
  return o < 0 ? [...t, n] : [...t.slice(0, o + 1), n, ...t.slice(o + 1)];
}
function ie(t, n) {
  return t instanceof Error && t.message ? t.message : n;
}
function it(t, n) {
  const [a, o] = $([]), [s, c] = $(!0), [l, i] = $(!0), [r, _] = $(null), [m, d] = $(0), [u, b] = $(0), f = t + " " + n, h = Be(f);
  h.current = f;
  const [E, w] = $(0), D = re(() => w((g) => g + 1), []);
  ge(() => {
    const g = new AbortController(), v = f;
    return o([]), b(0), d(0), _(null), c(!0), i(!0), Ie(t, n, 0, Se, g.signal).then((y) => {
      h.current === v && (o(y.items), d(y.total));
    }).catch((y) => {
      g.signal.aborted || h.current !== v || _(ie(y, "댓글을 불러오지 못했어요."));
    }).finally(() => {
      h.current === v && (c(!1), i(!1));
    }), () => g.abort();
  }, [t, n, f, E]);
  const X = a.filter(je).length < m, P = re(() => {
    if (s || !X) return;
    const g = u + 1, v = h.current;
    c(!0), Ie(t, n, g, Se).then((y) => {
      h.current === v && (o((B) => [...B, ...y.items]), d(y.total), b(g));
    }).catch((y) => {
      h.current === v && _(ie(y, "댓글을 더 불러오지 못했어요."));
    }).finally(() => {
      h.current === v && c(!1);
    });
  }, [s, X, u, t, n]), V = re(async (g, v) => {
    const y = g.trim();
    if (!y) return !1;
    const B = -Date.now(), C = {
      id: B,
      targetType: t,
      targetId: n,
      parentId: v != null ? v : null,
      authorName: "나",
      content: y,
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      deleted: !1,
      mine: !0,
      pending: !0
    }, M = h.current;
    o((S) => rt(S, C)), _(null);
    try {
      const S = await ot(t, n, y, v);
      return h.current !== M || (o((H) => H.map((k) => k.id === B ? S : k)), v === void 0 && d((H) => H + 1)), !0;
    } catch (S) {
      return h.current !== M || (o((H) => H.filter((k) => k.id !== B)), _(ie(S, "댓글을 등록하지 못했어요."))), !1;
    }
  }, [t, n]), F = re(async (g, v) => {
    const y = v.trim();
    if (!y) return !1;
    const B = h.current;
    try {
      const C = await st(g, y);
      return h.current !== B || o((M) => M.map((S) => S.id === g ? C : S)), !0;
    } catch (C) {
      return h.current === B && _(ie(C, "댓글을 수정하지 못했어요.")), !1;
    }
  }, []), le = re(async (g) => {
    const v = h.current;
    try {
      const y = await ct(g);
      return h.current !== v ? !0 : y === "soft-deleted" ? (o((B) => B.map((C) => C.id === g ? { ...C, deleted: !0, mine: !1, content: void 0, authorName: void 0 } : C)), !0) : (o((B) => {
        const C = B.find((k) => k.id === g), M = B.filter((k) => k.id !== g);
        if (!C) return M;
        if (je(C))
          return d((k) => Math.max(0, k - 1)), M;
        const S = C.parentId, H = M.find((k) => k.id === S);
        return H && H.deleted && !M.some((k) => k.parentId === S) ? (d((k) => Math.max(0, k - 1)), M.filter((k) => k.id !== S)) : M;
      }), !0);
    } catch (y) {
      return h.current === v && _(ie(y, "댓글을 삭제하지 못했어요.")), !1;
    }
  }, []);
  return {
    items: a,
    loading: s,
    initialLoading: l,
    error: r,
    count: a.filter((g) => !g.deleted).length,
    hasMore: X,
    loadMore: P,
    reload: D,
    add: V,
    edit: F,
    remove: le
  };
}
const _t = "_thread_1layy_9", dt = "_head_1layy_28", mt = "_headTitle_1layy_37", ut = "_headCount_1layy_43", pt = "_list_1layy_54", ht = "_row_1layy_61", bt = "_isReply_1layy_73", gt = "_pending_1layy_80", ft = "_avatar_1layy_84", yt = "_avatarGhost_1layy_98", Et = "_body_1layy_103", vt = "_meta_1layy_108", kt = "_author_1layy_116", Nt = "_dept_1layy_122", $t = "_time_1layy_130", wt = "_text_1layy_135", xt = "_textDeleted_1layy_143", jt = "_acts_1layy_148", Ft = "_act_1layy_148", Bt = "_actDanger_1layy_169", Ct = "_empty_1layy_175", Lt = "_error_1layy_182", It = "_skeleton_1layy_196", St = "_more_1layy_219", At = "_foot_1layy_245", Dt = "_composer_1layy_252", Mt = "_composerInput_1layy_261", Tt = "_composerActions_1layy_284", Rt = "_btn_1layy_291", zt = "_btnPrimary_1layy_301", qt = "_btnGhost_1layy_310", p = {
  thread: _t,
  head: dt,
  headTitle: mt,
  headCount: ut,
  list: pt,
  row: ht,
  isReply: bt,
  pending: gt,
  avatar: ft,
  avatarGhost: yt,
  body: Et,
  meta: vt,
  author: kt,
  dept: Nt,
  time: $t,
  text: wt,
  textDeleted: xt,
  acts: jt,
  act: Ft,
  actDanger: Bt,
  empty: Ct,
  error: Lt,
  skeleton: It,
  more: St,
  foot: At,
  composer: Dt,
  composerInput: Mt,
  composerActions: Tt,
  btn: Rt,
  btnPrimary: zt,
  btnGhost: qt
}, Ae = ["#3B82F6", "#7C3AED", "#10B981", "#F97316", "#EF4444", "#0EA5E9"];
function Xt(t) {
  let n = 0;
  for (let a = 0; a < t.length; a += 1) n = (n * 31 + t.charCodeAt(a)) % 997;
  return Ae[n % Ae.length];
}
function Pt(t) {
  const n = t.trim();
  return n ? n[0].toUpperCase() : "?";
}
const De = 6e4, Me = 36e5, Te = 864e5, Wt = 6048e5;
function Ot(t) {
  const n = new Date(t).getTime();
  if (Number.isNaN(n)) return "";
  const a = Date.now() - n;
  if (a < De) return "방금";
  if (a < Me) return `${Math.floor(a / De)}분 전`;
  if (a < Te) return `${Math.floor(a / Me)}시간 전`;
  if (a < Wt) return `${Math.floor(a / Te)}일 전`;
  const o = new Date(n), s = (c) => c < 10 ? `0${c}` : String(c);
  return `${o.getFullYear()}.${s(o.getMonth() + 1)}.${s(o.getDate())}`;
}
function Fe({
  placeholder: t,
  submitLabel: n,
  autoFocus: a,
  initialValue: o,
  onSubmit: s,
  onCancel: c
}) {
  const [l, i] = $(o != null ? o : ""), [r, _] = $(!1), m = Be(null);
  ge(() => {
    a && m.current && m.current.focus();
  }, [a]);
  const d = async () => {
    const u = l.trim();
    if (!u || r) return;
    _(!0);
    const b = await s(u);
    _(!1), b && i("");
  };
  return /* @__PURE__ */ e.createElement("div", { className: p.composer }, /* @__PURE__ */ e.createElement(
    "textarea",
    {
      ref: m,
      className: p.composerInput,
      rows: o === void 0 ? 2 : 3,
      placeholder: t,
      value: l,
      disabled: r,
      onChange: (u) => i(u.target.value),
      onKeyDown: (u) => {
        const b = u.nativeEvent.isComposing;
        u.key === "Enter" && !u.shiftKey && !b && (u.preventDefault(), d()), u.key === "Escape" && c && (u.nativeEvent.stopPropagation(), c());
      }
    }
  ), /* @__PURE__ */ e.createElement("div", { className: p.composerActions }, c && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: c,
      disabled: r
    },
    "취소"
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnPrimary}`,
      onClick: () => void d(),
      disabled: r || !l.trim()
    },
    r ? "보내는 중…" : n
  )));
}
function Gt({
  item: t,
  replying: n,
  editing: a,
  onReply: o,
  onEdit: s,
  onSubmitReply: c,
  onSubmitEdit: l,
  onDelete: i,
  onCancel: r
}) {
  var u, b;
  const _ = at(t), m = _ ? ` ${p.isReply}` : "";
  if (t.deleted)
    return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}` }, /* @__PURE__ */ e.createElement("span", { className: `${p.avatar} ${p.avatarGhost}` }, "·"), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: `${p.text} ${p.textDeleted}` }, "삭제된 댓글입니다")));
  const d = (u = t.authorName) != null ? u : "anonymous";
  return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}${t.pending ? ` ${p.pending}` : ""}` }, /* @__PURE__ */ e.createElement("span", { className: p.avatar, style: { background: Xt(d) } }, Pt(d)), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: p.meta }, /* @__PURE__ */ e.createElement("span", { className: p.author }, d), t.dept && /* @__PURE__ */ e.createElement("span", { className: p.dept }, t.dept), /* @__PURE__ */ e.createElement("span", { className: p.time }, Ot(t.createdAt)), t.updatedAt && /* @__PURE__ */ e.createElement("span", { className: p.time }, "(수정됨)")), a ? /* @__PURE__ */ e.createElement(
    Fe,
    {
      placeholder: "댓글을 수정합니다",
      submitLabel: "수정",
      autoFocus: !0,
      initialValue: (b = t.content) != null ? b : "",
      onSubmit: l,
      onCancel: r
    }
  ) : /* @__PURE__ */ e.createElement("div", { className: p.text }, t.content), !a && !t.pending && /* @__PURE__ */ e.createElement("div", { className: p.acts }, !_ && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: o }, "답글"), t.mine && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: s }, "수정"), t.mine && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.act} ${p.actDanger}`,
      onClick: i
    },
    "삭제"
  )), n && /* @__PURE__ */ e.createElement(
    Fe,
    {
      placeholder: `${d} 님에게 답글`,
      submitLabel: "답글 등록",
      autoFocus: !0,
      onSubmit: c,
      onCancel: r
    }
  )));
}
function El({
  targetType: t,
  targetId: n,
  onCountChange: a,
  autoFocus: o,
  showHeader: s = !0,
  className: c,
  style: l
}) {
  const { items: i, initialLoading: r, loading: _, error: m, count: d, hasMore: u, loadMore: b, reload: f, add: h, edit: E, remove: w } = it(t, n), [D, R] = $(null), [X, P] = $(null);
  ge(() => {
    R(null), P(null);
  }, [t, n]);
  const V = Be(a);
  return V.current = a, ge(() => {
    !r && V.current && V.current(d);
  }, [d, r]), /* @__PURE__ */ e.createElement("div", { className: c ? `${p.thread} ${c}` : p.thread, style: l }, s && /* @__PURE__ */ e.createElement("div", { className: p.head }, /* @__PURE__ */ e.createElement("span", { className: p.headTitle }, "댓글"), /* @__PURE__ */ e.createElement("span", { className: p.headCount }, d)), /* @__PURE__ */ e.createElement("div", { className: p.list }, r && /* @__PURE__ */ e.createElement("div", { className: p.skeleton }, /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null)), m && /* @__PURE__ */ e.createElement("div", { className: p.error }, /* @__PURE__ */ e.createElement("span", null, m), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: f
    },
    "다시 시도"
  )), !r && !m && i.length === 0 && /* @__PURE__ */ e.createElement("div", { className: p.empty }, "첫 댓글을 남겨 보세요."), i.map((F) => /* @__PURE__ */ e.createElement(
    Gt,
    {
      key: F.id,
      item: F,
      replying: D === F.id,
      editing: X === F.id,
      onReply: () => {
        P(null), R(F.id);
      },
      onEdit: () => {
        R(null), P(F.id);
      },
      onCancel: () => {
        R(null), P(null);
      },
      onSubmitReply: async (le) => {
        const g = await h(le, F.id);
        return g && R(null), g;
      },
      onSubmitEdit: async (le) => {
        const g = await E(F.id, le);
        return g && P(null), g;
      },
      onDelete: () => {
        w(F.id);
      }
    }
  )), u && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.more, onClick: b, disabled: _ }, _ ? "불러오는 중…" : "이전 댓글 더 보기")), /* @__PURE__ */ e.createElement("div", { className: p.foot }, /* @__PURE__ */ e.createElement(
    Fe,
    {
      placeholder: "댓글을 입력하세요 (Enter 전송, Shift+Enter 줄바꿈)",
      submitLabel: "등록",
      autoFocus: o,
      onSubmit: (F) => h(F)
    }
  )));
}
function vl(t, n) {
  const [a, o] = $({}), [s, c] = $(!1), [l, i] = $(0), r = n.join(",");
  return ge(() => {
    const _ = r ? r.split(",") : [];
    if (_.length === 0) {
      o({});
      return;
    }
    const m = new AbortController();
    return c(!0), lt(t, _, m.signal).then((d) => {
      m.signal.aborted || o(d);
    }).catch(() => {
      m.signal.aborted || o({});
    }).finally(() => {
      m.signal.aborted || c(!1);
    }), () => m.abort();
  }, [t, r, l]), {
    counts: a,
    loading: s,
    reload: () => i((_) => _ + 1)
  };
}
const Kt = "_card_epi3f_1", Ut = "_header_epi3f_8", Vt = "_headerNoDivider_epi3f_13", Ht = "_body_epi3f_17", Jt = "_paddingSm_epi3f_22", Zt = "_paddingMd_epi3f_26", Yt = "_paddingLg_epi3f_30", W = {
  card: Kt,
  header: Ut,
  headerNoDivider: Vt,
  body: Ht,
  paddingSm: Jt,
  paddingMd: Zt,
  paddingLg: Yt
};
function kl({
  children: t,
  header: n,
  padding: a = "md",
  radius: o,
  headerDivider: s = !0,
  headerBackground: c,
  headerPadding: l,
  headerBorderColor: i,
  className: r
}) {
  const _ = typeof a == "number" ? "" : a === "sm" ? W.paddingSm : a === "lg" ? W.paddingLg : W.paddingMd, m = typeof a == "number" ? { padding: a } : void 0, d = r ? `${W.card} ${r}` : W.card, u = s ? W.header : `${W.header} ${W.headerNoDivider}`, b = {
    ...c !== void 0 ? { background: c } : {},
    ...l !== void 0 ? { padding: l } : {},
    ...i !== void 0 ? { borderBottomColor: i } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: d, style: o !== void 0 ? { borderRadius: o } : void 0 }, n && /* @__PURE__ */ e.createElement("div", { className: u, style: b }, n), /* @__PURE__ */ e.createElement("div", { className: `${W.body} ${_}`, style: m }, t));
}
const Qt = "_horizontal_mkht7_1", en = "_vertical_mkht7_8", Re = {
  horizontal: Qt,
  vertical: en
};
function Nl({ orientation: t = "horizontal", spacing: n = 0, color: a }) {
  const o = t === "vertical";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: o ? Re.vertical : Re.horizontal,
      style: {
        ...o ? { marginLeft: n, marginRight: n } : { marginTop: n, marginBottom: n },
        ...a !== void 0 ? { backgroundColor: a } : {}
      },
      role: "separator",
      "aria-orientation": t
    }
  );
}
const tn = "_root_nvy8t_1", nn = "_icon_nvy8t_7", an = "_iconBadge_nvy8t_15", on = "_titleGroup_nvy8t_25", sn = "_title_nvy8t_25", cn = "_subtitle_nvy8t_41", ln = "_trailing_nvy8t_49", rn = "_closeButton_nvy8t_58", J = {
  root: tn,
  icon: nn,
  iconBadge: an,
  titleGroup: on,
  title: sn,
  subtitle: cn,
  trailing: ln,
  closeButton: rn
};
function $l({
  icon: t,
  iconColor: n,
  iconBadge: a = !1,
  iconBadgeColor: o = "#3b82f6",
  iconBadgeGradient: s,
  iconBadgeSize: c,
  title: l,
  titleWeight: i,
  titleSize: r,
  subtitle: _,
  subtitleColor: m,
  subtitleSize: d,
  trailing: u,
  onClose: b
}) {
  const f = {
    ...i !== void 0 ? { fontWeight: i } : {},
    ...r !== void 0 ? { fontSize: r } : {}
  }, h = {
    ...m !== void 0 ? { color: m } : {},
    ...d !== void 0 ? { fontSize: d } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: J.root }, t && a && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: J.iconBadge,
      style: {
        ...s ? { background: `linear-gradient(135deg, ${s[0]}, ${s[1]})`, color: "#fff" } : { backgroundColor: `${o}1A`, color: o },
        ...c !== void 0 ? { width: c, height: c } : {}
      }
    },
    t
  ), t && !a && /* @__PURE__ */ e.createElement("span", { className: J.icon, style: n !== void 0 ? { color: n } : void 0 }, t), /* @__PURE__ */ e.createElement("div", { className: J.titleGroup }, /* @__PURE__ */ e.createElement("span", { className: J.title, style: f }, l), _ && /* @__PURE__ */ e.createElement("span", { className: J.subtitle, style: h }, _)), u && /* @__PURE__ */ e.createElement("div", { className: J.trailing }, u), b && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: J.closeButton,
      onClick: b,
      "aria-label": "닫기"
    },
    "×"
  ));
}
const _n = "_badge_19977_1", dn = {
  badge: _n
};
function wl({
  size: t = 32,
  gradient: n = ["#7C3AED", "#3B82F6"],
  icon: a
}) {
  const o = t * 0.55;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: dn.badge,
      style: {
        width: t,
        height: t,
        background: `linear-gradient(135deg, ${n[0]}, ${n[1]})`
      }
    },
    a != null ? a : /* @__PURE__ */ e.createElement("svg", { width: o, height: o, viewBox: "0 0 24 24", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" }))
  );
}
const mn = "_wrapper_ccmq2_1", un = "_image_ccmq2_8", pn = "_fallback_ccmq2_16", hn = "_statusDot_ccmq2_29", ve = {
  wrapper: mn,
  image: un,
  fallback: pn,
  statusDot: hn
}, bn = {
  on: "#22C55E",
  away: "#F59E0B",
  off: "#94A3B8"
};
function gn(t) {
  const n = t == null ? void 0 : t.trim();
  return n ? Array.from(n)[0].toUpperCase() : "";
}
const $e = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#10B981",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#D946EF",
  "#EC4899"
];
function fn(t) {
  const n = t == null ? void 0 : t.trim();
  if (!n) return $e[5];
  let a = 0;
  for (let o = 0; o < n.length; o += 1)
    a = a * 31 + n.charCodeAt(o) | 0;
  return $e[Math.abs(a) % $e.length];
}
function Ke({
  src: t,
  fallbackText: n,
  alt: a,
  size: o = 32,
  statusDot: s,
  color: c,
  ring: l = !1,
  ringColor: i = "#fff"
}) {
  var d;
  const [r, _] = $(), m = !!t && r !== t;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ve.wrapper,
      style: {
        width: o,
        height: o,
        ...l ? { boxShadow: `0 0 0 2px ${i}` } : {}
      }
    },
    m ? /* @__PURE__ */ e.createElement(
      "img",
      {
        className: ve.image,
        src: t,
        alt: (d = a != null ? a : n) != null ? d : "",
        onError: () => _(t)
      }
    ) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ve.fallback,
        style: {
          backgroundColor: c != null ? c : fn(n),
          fontSize: Math.max(10, o * 0.45)
        }
      },
      gn(n)
    ),
    s && /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ve.statusDot,
        style: {
          backgroundColor: bn[s],
          width: Math.max(8, o * 0.28),
          height: Math.max(8, o * 0.28)
        }
      }
    )
  );
}
const yn = "_stack_y8phg_1", En = "_item_y8phg_6", vn = "_overflow_y8phg_18", ke = {
  stack: yn,
  item: En,
  overflow: vn
};
function xl({
  avatars: t,
  max: n = 4,
  size: a = 32
}) {
  const o = t.slice(0, n), s = t.length - o.length;
  return /* @__PURE__ */ e.createElement("span", { className: ke.stack }, o.map((c, l) => /* @__PURE__ */ e.createElement("span", { key: l, className: ke.item, style: { zIndex: o.length - l } }, /* @__PURE__ */ e.createElement(Ke, { src: c.src, alt: c.alt, fallbackText: c.fallbackText, size: a }))), s > 0 && /* @__PURE__ */ e.createElement("span", { className: ke.item, style: { zIndex: 0 } }, /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ke.overflow,
      style: { width: a, height: a, fontSize: Math.max(10, a * 0.36) }
    },
    "+",
    s
  )));
}
const kn = "_badge_1mjda_1", Nn = "_pill_1mjda_15", $n = "_dot_1mjda_19", wn = "_dotPulse_1mjda_26", xn = "_outline_1mjda_40", jn = "_soft_1mjda_46", _e = {
  badge: kn,
  pill: Nn,
  dot: $n,
  dotPulse: wn,
  "ax-badge-pulse": "_ax-badge-pulse_1mjda_1",
  default: "_default_1mjda_35",
  outline: xn,
  soft: jn
};
function jl({
  label: t,
  variant: n = "default",
  color: a,
  background: o,
  textColor: s,
  shape: c = "rounded",
  dot: l = !1,
  dotColor: i,
  dotPulse: r = !1,
  border: _ = !1,
  borderColor: m = "currentColor"
}) {
  var f;
  const d = {};
  a && (n === "default" ? (d.backgroundColor = a, d.color = "#fff") : n === "outline" ? (d.borderColor = a, d.color = a) : (d.backgroundColor = `${a}1A`, d.color = a)), o !== void 0 && (d.backgroundColor = o), s !== void 0 && (d.color = s), _ && (d.borderColor = m);
  const u = [
    _e.badge,
    _e[n],
    c === "pill" ? _e.pill : ""
  ].filter(Boolean).join(" "), b = [_e.dot, r ? _e.dotPulse : ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ e.createElement("span", { className: u, style: d }, l && /* @__PURE__ */ e.createElement("span", { className: b, style: { backgroundColor: i != null ? i : (f = s != null ? s : a) != null ? f : "currentColor" } }), t);
}
const Fn = "_row_1k2ap_1", Bn = "_reply_1k2ap_7", Cn = "_avatar_1k2ap_12", Ln = "_avatarImage_1k2ap_25", In = "_avatarFallback_1k2ap_32", Sn = "_body_1k2ap_44", An = "_headerLine_1k2ap_49", Dn = "_author_1k2ap_56", Mn = "_meta_1k2ap_62", Tn = "_text_1k2ap_67", Rn = "_actionsRow_1k2ap_74", zn = "_actionBtn_1k2ap_81", L = {
  row: Fn,
  reply: Bn,
  avatar: Cn,
  avatarImage: Ln,
  avatarFallback: In,
  body: Sn,
  headerLine: An,
  author: Dn,
  meta: Mn,
  text: Tn,
  actionsRow: Rn,
  actionBtn: zn
};
function qn(t) {
  const n = t.trim();
  return n ? n[0].toUpperCase() : "";
}
function Fl({
  avatarSrc: t,
  author: n,
  meta: a,
  text: o,
  likeCount: s,
  replyCount: c,
  isReply: l = !1,
  onLikeClick: i,
  onReplyClick: r
}) {
  const [_, m] = $(!1), d = !!t && !_;
  return /* @__PURE__ */ e.createElement("div", { className: `${L.row} ${l ? L.reply : ""}` }, /* @__PURE__ */ e.createElement("span", { className: L.avatar }, d ? /* @__PURE__ */ e.createElement(
    "img",
    {
      className: L.avatarImage,
      src: t,
      alt: n,
      onError: () => m(!0)
    }
  ) : /* @__PURE__ */ e.createElement("span", { className: L.avatarFallback }, qn(n))), /* @__PURE__ */ e.createElement("div", { className: L.body }, /* @__PURE__ */ e.createElement("div", { className: L.headerLine }, /* @__PURE__ */ e.createElement("span", { className: L.author }, n), a && /* @__PURE__ */ e.createElement("span", { className: L.meta }, a)), /* @__PURE__ */ e.createElement("div", { className: L.text }, o), /* @__PURE__ */ e.createElement("div", { className: L.actionsRow }, /* @__PURE__ */ e.createElement("button", { type: "button", className: L.actionBtn, onClick: i }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })), typeof s == "number" && /* @__PURE__ */ e.createElement("span", null, s)), /* @__PURE__ */ e.createElement("button", { type: "button", className: L.actionBtn, onClick: r }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })), typeof c == "number" && /* @__PURE__ */ e.createElement("span", null, c)))));
}
const Xn = "_wrapper_79n51_1", Pn = {
  wrapper: Xn
}, Wn = {
  pdf: { label: "PDF", color: "#B91C1C", bg: "#FEF2F2" },
  doc: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  docx: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  xls: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  xlsx: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  ppt: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  pptx: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  zip: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  rar: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  "7z": { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  jpg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  jpeg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  png: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  gif: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  svg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  mp4: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  mov: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  avi: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  txt: { label: "TXT", color: "#334155", bg: "#F8FAFC" }
}, On = { label: "FILE", color: "#64748B", bg: "#F1F5F9" };
function Gn({ ext: t, size: n = 32 }) {
  var l;
  const a = t.trim().toLowerCase().replace(/^\./, ""), { label: o, color: s, bg: c } = (l = Wn[a]) != null ? l : On;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Pn.wrapper,
      style: {
        width: n,
        height: n,
        backgroundColor: c,
        color: s,
        fontSize: Math.max(8, n * 0.26)
      }
    },
    o
  );
}
const Kn = "_chip_1jhj8_1", Un = "_clickable_1jhj8_12", Vn = "_icon_1jhj8_21", Hn = "_info_1jhj8_26", Jn = "_name_1jhj8_33", Zn = "_size_1jhj8_42", Yn = "_chipError_1jhj8_48", Qn = "_chipDone_1jhj8_53", ea = "_status_1jhj8_57", ta = "_statusError_1jhj8_66", na = "_statusDone_1jhj8_67", aa = "_statusIcon_1jhj8_69", oa = "_statusLabel_1jhj8_71", sa = "_progressTrack_1jhj8_78", ca = "_progressFill_1jhj8_88", la = "_actionBtn_1jhj8_96", N = {
  chip: Kn,
  clickable: Un,
  icon: Vn,
  info: Hn,
  name: Jn,
  size: Zn,
  chipError: Yn,
  chipDone: Qn,
  status: ea,
  statusError: ta,
  statusDone: na,
  statusIcon: aa,
  statusLabel: oa,
  progressTrack: sa,
  progressFill: ca,
  actionBtn: la
};
function Bl({
  name: t,
  ext: n,
  size: a,
  onRemove: o,
  downloadable: s = !1,
  onClick: c,
  status: l,
  statusText: i,
  percent: r
}) {
  const _ = l === "error" ? N.chipError : l === "done" ? N.chipDone : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${N.chip} ${c ? N.clickable : ""} ${_}`,
      onClick: c,
      title: l === "error" ? i : void 0
    },
    n && /* @__PURE__ */ e.createElement("span", { className: N.icon }, /* @__PURE__ */ e.createElement(Gn, { ext: n, size: 28 })),
    /* @__PURE__ */ e.createElement("span", { className: N.info }, /* @__PURE__ */ e.createElement("span", { className: N.name }, t), i ? /* @__PURE__ */ e.createElement("span", { className: `${N.status} ${l === "error" ? N.statusError : l === "done" ? N.statusDone : ""}` }, l === "error" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ e.createElement("path", { d: "M12 7v6M12 16.5v.01" })), l === "done" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M4 12.5l5 5L20 6.5" })), /* @__PURE__ */ e.createElement("span", { className: N.statusLabel }, i)) : a ? /* @__PURE__ */ e.createElement("span", { className: N.size }, a) : null, l === "processing" && /* @__PURE__ */ e.createElement("span", { className: N.progressTrack }, /* @__PURE__ */ e.createElement("span", { className: N.progressFill, style: { width: `${Math.max(0, Math.min(100, r != null ? r : 0))}%` } }))),
    s ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "download",
        onClick: (m) => m.stopPropagation()
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M12 3v12M7 10l5 5 5-5M4 21h16" }))
    ) : o ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "remove",
        onClick: (m) => {
          m.stopPropagation(), o();
        }
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18M6 6l12 12" }))
    ) : null
  );
}
const ra = "_list_1yxwc_1", ia = "_row_1yxwc_6", _a = "_inline_1yxwc_15", da = "_label_1yxwc_22", ma = "_value_1yxwc_29", ua = "_stacked_1yxwc_35", pa = "_bold_1yxwc_51", te = {
  list: ra,
  row: ia,
  inline: _a,
  label: da,
  value: ma,
  stacked: ua,
  bold: pa
};
function Cl({
  rows: t,
  direction: n = "inline"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: `${te.list} ${te[n]}` }, t.map((a, o) => /* @__PURE__ */ e.createElement("div", { key: o, className: te.row }, /* @__PURE__ */ e.createElement("span", { className: te.label }, a.label), /* @__PURE__ */ e.createElement("span", { className: `${te.value} ${a.bold ? te.bold : ""}` }, a.value))));
}
const ha = "_container_2r163_1", ba = "_row_2r163_5", ga = "_clickable_2r163_12", fa = "_leading_2r163_20", ya = "_main_2r163_26", Ea = "_titleLine_2r163_34", va = "_title_2r163_34", ka = "_tags_2r163_50", Na = "_meta_2r163_57", $a = "_actions_2r163_62", wa = "_expandable_2r163_69", T = {
  container: ha,
  row: ba,
  clickable: ga,
  leading: fa,
  main: ya,
  titleLine: Ea,
  title: va,
  tags: ka,
  meta: Na,
  actions: $a,
  expandable: wa
};
function Ll({
  leading: t,
  title: n,
  meta: a,
  tags: o,
  actions: s,
  expandableContent: c,
  expanded: l = !1,
  onClick: i
}) {
  return /* @__PURE__ */ e.createElement("div", { className: T.container }, /* @__PURE__ */ e.createElement("div", { className: `${T.row} ${i ? T.clickable : ""}`, onClick: i }, t && /* @__PURE__ */ e.createElement("div", { className: T.leading }, t), /* @__PURE__ */ e.createElement("div", { className: T.main }, /* @__PURE__ */ e.createElement("div", { className: T.titleLine }, /* @__PURE__ */ e.createElement("span", { className: T.title }, n), o && /* @__PURE__ */ e.createElement("span", { className: T.tags }, o)), a && /* @__PURE__ */ e.createElement("div", { className: T.meta }, a)), s && /* @__PURE__ */ e.createElement("div", { className: T.actions, onClick: (r) => r.stopPropagation() }, s)), l && c && /* @__PURE__ */ e.createElement("div", { className: T.expandable }, c));
}
const xa = "_row_xzgny_1", ja = "_info_xzgny_8", Fa = "_name_xzgny_16", Ba = "_subtitle_xzgny_25", Ca = "_status_xzgny_33", de = {
  row: xa,
  info: ja,
  name: Fa,
  subtitle: Ba,
  status: Ca
};
function Il({
  avatarSrc: t,
  name: n,
  subtitle: a,
  status: o,
  statusColor: s = "#64748B",
  statusBg: c = "#F1F5F9"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: de.row }, /* @__PURE__ */ e.createElement(Ke, { src: t, fallbackText: n, size: 36 }), /* @__PURE__ */ e.createElement("div", { className: de.info }, /* @__PURE__ */ e.createElement("span", { className: de.name }, n), a && /* @__PURE__ */ e.createElement("span", { className: de.subtitle }, a)), o && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: de.status,
      style: { color: s, backgroundColor: c }
    },
    o
  ));
}
const La = "_row_qoxwr_1", Ia = "_clickable_qoxwr_9", Sa = "_rank_qoxwr_17", Aa = "_title_qoxwr_25", Da = "_trailing_qoxwr_36", me = {
  row: La,
  clickable: Ia,
  rank: Sa,
  title: Aa,
  trailing: Da
}, Ma = {
  1: "#F59E0B",
  2: "#94A3B8",
  3: "#B45309"
};
function Sl({
  rank: t,
  rankColor: n,
  title: a,
  trailingText: o,
  onClick: s
}) {
  var l;
  const c = (l = n != null ? n : Ma[t]) != null ? l : "#64748B";
  return /* @__PURE__ */ e.createElement("div", { className: `${me.row} ${s ? me.clickable : ""}`, onClick: s }, /* @__PURE__ */ e.createElement("span", { className: me.rank, style: { color: c } }, t), /* @__PURE__ */ e.createElement("span", { className: me.title }, a), o && /* @__PURE__ */ e.createElement("span", { className: me.trailing }, o));
}
const Ta = "_badge_1qibj_1", Ra = "_sm_1qibj_11", za = "_md_1qibj_16", qa = "_overdue_1qibj_21", Xa = "_warning_1qibj_26", Pa = "_progress_1qibj_31", Wa = "_success_1qibj_36", Oa = "_info_1qibj_41", Ga = "_neutral_1qibj_46", we = {
  badge: Ta,
  sm: Ra,
  md: za,
  overdue: qa,
  warning: Xa,
  progress: Pa,
  success: Wa,
  info: Oa,
  neutral: Ga
};
function Al({
  label: t,
  tone: n = "neutral",
  size: a = "md",
  background: o,
  textColor: s
}) {
  const c = {};
  return o !== void 0 && (c.backgroundColor = o), s !== void 0 && (c.color = s), /* @__PURE__ */ e.createElement("span", { className: `${we.badge} ${we[n]} ${we[a]}`, style: c }, t);
}
const Ka = "_wrapper_14p14_1", Ua = "_avatar_14p14_11", Va = "_body_14p14_21", Ha = "_message_14p14_26", Ja = "_dots_14p14_32", Za = "_dot_14p14_32", Ya = "_action_14p14_70", Qa = "_actionIcon_14p14_89", eo = "_gradientWrapper_14p14_95", to = "_bareIcon_14p14_100", no = "_ctaButton_14p14_109", x = {
  wrapper: Ka,
  avatar: Ua,
  body: Va,
  message: Ha,
  dots: Ja,
  dot: Za,
  action: Ya,
  actionIcon: Qa,
  gradientWrapper: eo,
  bareIcon: to,
  ctaButton: no
};
function ze() {
  return /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 1.5l1.4 3.9L13.3 6.8l-3.9 1.4L8 12.1l-1.4-3.9L2.7 6.8l3.9-1.4L8 1.5z",
      fill: "currentColor"
    }
  ));
}
function qe() {
  return /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3 7h8M7.5 3.5L11 7l-3.5 3.5",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ));
}
function Dl({
  message: t,
  accentColor: n = "#7C3AED",
  buttonLabel: a,
  buttonIcon: o,
  onAction: s,
  phase: c = "complete",
  variant: l = "card",
  gradientColors: i = ["#EEF4FF", "#F3EEFF"]
}) {
  const r = l === "gradient-cta";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [x.wrapper, r ? x.gradientWrapper : ""].join(" "),
      style: r ? { borderColor: `${n}33`, background: `linear-gradient(135deg, ${i[0]}, ${i[1]})` } : { borderColor: `${n}33` }
    },
    r ? /* @__PURE__ */ e.createElement("span", { className: x.bareIcon, style: { color: n } }, /* @__PURE__ */ e.createElement(ze, null)) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: x.avatar,
        style: { backgroundColor: `${n}1A`, color: n }
      },
      /* @__PURE__ */ e.createElement(ze, null)
    ),
    /* @__PURE__ */ e.createElement("div", { className: x.body }, c === "loading" ? /* @__PURE__ */ e.createElement("span", { className: x.dots }, /* @__PURE__ */ e.createElement("span", { className: x.dot, style: { backgroundColor: n } }), /* @__PURE__ */ e.createElement("span", { className: x.dot, style: { backgroundColor: n } }), /* @__PURE__ */ e.createElement("span", { className: x.dot, style: { backgroundColor: n } })) : /* @__PURE__ */ e.createElement("span", { className: x.message, style: r ? { color: n } : void 0 }, t)),
    a && s && (r ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: x.ctaButton,
        style: { backgroundColor: n },
        onClick: s
      },
      /* @__PURE__ */ e.createElement("span", null, a),
      /* @__PURE__ */ e.createElement("span", { className: x.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(qe, null) : o)
    ) : /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: x.action,
        style: { color: n },
        onClick: s
      },
      /* @__PURE__ */ e.createElement("span", null, a),
      /* @__PURE__ */ e.createElement("span", { className: x.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(qe, null) : o)
    ))
  );
}
const ao = "_wrapper_68zkp_1", oo = "_bordered_68zkp_13", so = "_compact_68zkp_17", co = "_icon_68zkp_23", lo = "_title_68zkp_31", ro = "_description_68zkp_38", io = "_action_68zkp_46", Y = {
  wrapper: ao,
  bordered: oo,
  compact: so,
  icon: co,
  title: lo,
  description: ro,
  action: io
};
function _o() {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15L20 8l14 7-14 7-14-7z",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15v11l14 7 14-7V15",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement("path", { d: "M20 22v11", stroke: "#94A3B8", strokeWidth: "1.6", strokeLinecap: "round" })
  );
}
function Ml({
  icon: t,
  hideIcon: n = !1,
  title: a,
  titleColor: o,
  titleSize: s,
  titleWeight: c,
  description: l,
  actionLabel: i,
  onAction: r,
  bordered: _ = !0,
  compact: m = !1
}) {
  const d = {
    ...o !== void 0 ? { color: o } : {},
    ...s !== void 0 ? { fontSize: s } : {},
    ...c !== void 0 ? { fontWeight: c } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [Y.wrapper, _ && !m ? Y.bordered : "", m ? Y.compact : ""].join(" ")
    },
    !n && /* @__PURE__ */ e.createElement("div", { className: Y.icon }, t != null ? t : /* @__PURE__ */ e.createElement(_o, null)),
    /* @__PURE__ */ e.createElement("p", { className: Y.title, style: d }, a),
    l && /* @__PURE__ */ e.createElement("p", { className: Y.description }, l),
    i && r && /* @__PURE__ */ e.createElement("button", { type: "button", className: Y.action, onClick: r }, i)
  );
}
const mo = "_wrapper_oide4_1", uo = "_toggle_oide4_7", po = "_toggleOpen_oide4_29", ho = "_panel_oide4_34", bo = "_text_oide4_41", ue = {
  wrapper: mo,
  toggle: uo,
  toggleOpen: po,
  panel: ho,
  text: bo
};
function Tl({
  label: t,
  summaryText: n,
  open: a,
  onToggle: o
}) {
  return /* @__PURE__ */ e.createElement("div", { className: ue.wrapper }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: [ue.toggle, a ? ue.toggleOpen : ""].join(" "),
      onClick: o,
      "aria-expanded": a
    },
    t
  ), a && /* @__PURE__ */ e.createElement("div", { className: ue.panel }, /* @__PURE__ */ e.createElement("p", { className: ue.text }, n)));
}
const go = "_wrapper_96dw1_1", fo = "_labelRow_96dw1_8", yo = "_label_96dw1_8", Eo = "_value_96dw1_21", vo = "_track_96dw1_27", ko = "_xs_96dw1_35", No = "_sm_96dw1_39", $o = "_md_96dw1_43", wo = "_square_96dw1_47", xo = "_fill_96dw1_51", O = {
  wrapper: go,
  labelRow: fo,
  label: yo,
  value: Eo,
  track: vo,
  xs: ko,
  sm: No,
  md: $o,
  square: wo,
  fill: xo
};
function Rl({
  value: t,
  max: n = 100,
  label: a,
  color: o = "#3B82F6",
  gradient: s,
  size: c = "md",
  rounded: l = !0,
  height: i,
  trackColor: r
}) {
  const _ = n > 0 ? n : 100, m = Math.min(100, Math.max(0, t / _ * 100)), d = s ? { width: `${m}%`, background: `linear-gradient(90deg, ${s[0]}, ${s[1]})` } : { width: `${m}%`, backgroundColor: o }, u = {
    ...i !== void 0 ? { height: i } : {},
    ...r !== void 0 ? { background: r } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: O.wrapper }, a && /* @__PURE__ */ e.createElement("div", { className: O.labelRow }, /* @__PURE__ */ e.createElement("span", { className: O.label }, a), /* @__PURE__ */ e.createElement("span", { className: O.value }, Math.round(m), "%")), /* @__PURE__ */ e.createElement("div", { className: [O.track, O[c], l ? "" : O.square].join(" "), style: u }, /* @__PURE__ */ e.createElement("div", { className: [O.fill, l ? "" : O.square].join(" "), style: d })));
}
const jo = "_list_aixh6_1", Fo = "_vertical_aixh6_8", Bo = "_horizontal_aixh6_13", Co = "_item_aixh6_18", Lo = "_iconWrap_aixh6_41", Io = "_iconSvg_aixh6_51", So = "_spin_aixh6_56", Ao = "_label_aixh6_70", Do = "_item_active_aixh6_82", Mo = "_item_done_aixh6_87", To = "_connector_aixh6_91", Ro = "_cardList_aixh6_114", zo = "_cardItem_aixh6_122", qo = "_card_pending_aixh6_133", Xo = "_card_active_aixh6_142", Po = "_card_done_aixh6_152", j = {
  list: jo,
  vertical: Fo,
  horizontal: Bo,
  item: Co,
  iconWrap: Lo,
  iconSvg: Io,
  spin: So,
  "ax-step-spin": "_ax-step-spin_aixh6_1",
  label: Ao,
  item_active: Do,
  item_done: Mo,
  connector: To,
  cardList: Ro,
  cardItem: zo,
  card_pending: qo,
  card_active: Xo,
  card_done: Po
};
function Wo({ status: t }) {
  return t === "done" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: j.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "#F0FDF4", stroke: "#166534", strokeWidth: "1.5" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 10.2l2.4 2.4L14 7",
        stroke: "#166534",
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ) : t === "active" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: [j.iconSvg, j.spin].join(" "),
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "#E2E8F0",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18 10a8 8 0 00-8-8",
        stroke: "#3B82F6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      }
    )
  ) : /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: j.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "8", stroke: "#94A3B8", strokeWidth: "1.5" })
  );
}
function zl({
  steps: t,
  orientation: n = "vertical",
  variant: a = "timeline"
}) {
  const o = a === "card";
  return /* @__PURE__ */ e.createElement("ul", { className: [j.list, j[n], o ? j.cardList : ""].join(" ") }, t.map((s, c) => /* @__PURE__ */ e.createElement(
    "li",
    {
      key: `${s.label}-${c}`,
      className: [
        j.item,
        o ? j.cardItem : "",
        j[`item_${s.status}`],
        o ? j[`card_${s.status}`] : ""
      ].join(" ")
    },
    /* @__PURE__ */ e.createElement("span", { className: j.iconWrap }, /* @__PURE__ */ e.createElement(Wo, { status: s.status })),
    /* @__PURE__ */ e.createElement("span", { className: j.label }, s.label),
    !o && c < t.length - 1 && /* @__PURE__ */ e.createElement("span", { className: j.connector })
  )));
}
const Oo = "_wrapper_1ohmw_1", Go = "_icon_1ohmw_7", Ko = "_dots_1ohmw_14", Uo = "_dot_1ohmw_14", Vo = "_sm_1ohmw_27", Ho = "_md_1ohmw_32", Q = {
  wrapper: Oo,
  icon: Go,
  dots: Ko,
  dot: Uo,
  "ax-typing-bounce": "_ax-typing-bounce_1ohmw_1",
  sm: Vo,
  md: Ho
};
function ql({ withIcon: t, size: n = "md" }) {
  return /* @__PURE__ */ e.createElement("div", { className: Q.wrapper }, t && /* @__PURE__ */ e.createElement("span", { className: Q.icon }, t), /* @__PURE__ */ e.createElement("span", { className: [Q.dots, Q[n]].join(" ") }, /* @__PURE__ */ e.createElement("span", { className: Q.dot }), /* @__PURE__ */ e.createElement("span", { className: Q.dot }), /* @__PURE__ */ e.createElement("span", { className: Q.dot })));
}
const Jo = "_container_85404_1", Zo = "_table_85404_9", Yo = "_row_85404_31", Qo = "_striped_85404_35", es = "_clickable_85404_43", ts = "_alignLeft_85404_47", ns = "_alignCenter_85404_51", as = "_alignRight_85404_55", os = "_emptyCell_85404_59", G = {
  container: Jo,
  table: Zo,
  row: Yo,
  striped: Qo,
  clickable: es,
  alignLeft: ts,
  alignCenter: ns,
  alignRight: as,
  emptyCell: os
};
function Xl({
  columns: t,
  rows: n,
  striped: a = !0,
  onRowClick: o,
  emptyMessage: s = "데이터가 없습니다"
}) {
  const c = (l) => l === "center" ? G.alignCenter : l === "right" ? G.alignRight : G.alignLeft;
  return /* @__PURE__ */ e.createElement("div", { className: G.container }, /* @__PURE__ */ e.createElement("table", { className: G.table }, /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, t.map((l) => /* @__PURE__ */ e.createElement(
    "th",
    {
      key: l.key,
      className: c(l.align),
      style: l.width ? { width: l.width } : void 0
    },
    l.label
  )))), /* @__PURE__ */ e.createElement("tbody", null, n.length === 0 ? /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { className: G.emptyCell, colSpan: t.length }, s)) : n.map((l, i) => {
    const r = [
      G.row,
      a && i % 2 === 1 ? G.striped : "",
      o ? G.clickable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "tr",
      {
        key: i,
        className: r,
        onClick: o ? () => o(l, i) : void 0
      },
      t.map((_) => /* @__PURE__ */ e.createElement("td", { key: _.key, className: c(_.align) }, l[_.key]))
    );
  }))));
}
const ss = "_grid_plbcd_1", cs = "_cell_plbcd_6", ls = "_primaryCell_plbcd_16", rs = "_label_plbcd_21", is = "_value_plbcd_26", _s = "_note_plbcd_32", ne = {
  grid: ss,
  cell: cs,
  primaryCell: ls,
  label: rs,
  value: is,
  note: _s
};
function Pl({
  items: t,
  columns: n = 4,
  primaryFirst: a = !1,
  cellBackground: o,
  cellBorderColor: s,
  labelColor: c,
  valueColor: l,
  primaryBackground: i,
  primaryLabelColor: r,
  primaryValueColor: _,
  primaryNoteColor: m
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: ne.grid,
      style: { gridTemplateColumns: `repeat(${n}, 1fr)` }
    },
    t.map((d, u) => {
      const b = a && u === 0, f = [ne.cell, b ? ne.primaryCell : ""].filter(Boolean).join(" "), h = {};
      o !== void 0 && (h.background = o), s !== void 0 && (h.borderColor = s), b && i !== void 0 && (h.background = i, h.borderColor = "transparent");
      const E = {};
      c !== void 0 && (E.color = c), b && r !== void 0 && (E.color = r);
      const w = {};
      l !== void 0 && (w.color = l), b && _ !== void 0 && (w.color = _);
      const D = {};
      return b && m !== void 0 && (D.color = m), /* @__PURE__ */ e.createElement("div", { key: `${d.label}-${u}`, className: f, style: h }, /* @__PURE__ */ e.createElement("span", { className: ne.label, style: E }, d.label), /* @__PURE__ */ e.createElement("span", { className: ne.value, style: w }, d.value), d.note && /* @__PURE__ */ e.createElement("span", { className: ne.note, style: D }, d.note));
    })
  );
}
const ds = "_button_16ajt_1", ms = "_disabledSolid_16ajt_19", us = "_icon_16ajt_26", ps = "_label_16ajt_32", hs = "_fullWidth_16ajt_37", bs = "_sm_16ajt_41", gs = "_md_16ajt_47", fs = "_lg_16ajt_53", ys = "_primary_16ajt_59", Es = "_secondary_16ajt_70", vs = "_outline_16ajt_81", ks = "_ghost_16ajt_93", Ns = "_active_16ajt_104", $s = "_colorOverride_16ajt_116", ws = "_gradient_16ajt_126", xs = "_dashed_16ajt_135", js = "_pill_16ajt_139", A = {
  button: ds,
  disabledSolid: ms,
  icon: us,
  label: ps,
  fullWidth: hs,
  sm: bs,
  md: gs,
  lg: fs,
  primary: ys,
  secondary: Es,
  outline: vs,
  ghost: ks,
  active: Ns,
  colorOverride: $s,
  gradient: ws,
  dashed: xs,
  pill: js
};
function Wl({
  variant: t = "primary",
  size: n = "md",
  icon: a,
  iconPosition: o = "leading",
  disabled: s = !1,
  disabledVariant: c = "dim",
  onClick: l,
  children: i,
  fullWidth: r = !1,
  type: _ = "button",
  active: m = !1,
  color: d,
  background: u,
  borderColor: b,
  hoverColor: f,
  hoverBackground: h,
  gradient: E,
  borderStyle: w = "solid",
  shape: D = "rounded"
}) {
  const R = d !== void 0 || b !== void 0 || f !== void 0 || h !== void 0, X = [
    A.button,
    A[t],
    A[n],
    r ? A.fullWidth : "",
    s && c === "solid" ? A.disabledSolid : "",
    m ? A.active : "",
    R ? A.colorOverride : "",
    E || u ? A.gradient : "",
    w === "dashed" ? A.dashed : "",
    D === "pill" ? A.pill : ""
  ].filter(Boolean).join(" "), P = {
    ...d !== void 0 ? { "--ax-btn-color": d } : {},
    ...b !== void 0 ? { "--ax-btn-border": b } : {},
    ...f !== void 0 ? { "--ax-btn-hover-color": f } : {},
    ...h !== void 0 ? { "--ax-btn-hover-bg": h } : {},
    ...E ? { background: `linear-gradient(135deg, ${E[0]}, ${E[1]})` } : {},
    ...u !== void 0 ? { background: u } : {}
  }, V = a && /* @__PURE__ */ e.createElement("span", { className: A.icon }, a);
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: _,
      className: X,
      style: P,
      disabled: s,
      onClick: l
    },
    o === "leading" && V,
    /* @__PURE__ */ e.createElement("span", { className: A.label }, i),
    o === "trailing" && V
  );
}
const Fs = "_iconButton_1oiog_1", Bs = "_sm_1oiog_18", Cs = "_md_1oiog_23", Ls = "_lg_1oiog_28", Is = "_plain_1oiog_33", Ss = "_outline_1oiog_42", As = "_circle_1oiog_53", Ds = "_bordered_1oiog_62", Ms = "_tint_1oiog_73", Ts = "_active_1oiog_81", Rs = "_hoverBgOverride_1oiog_92", zs = "_gradient_1oiog_96", Z = {
  iconButton: Fs,
  sm: Bs,
  md: Cs,
  lg: Ls,
  plain: Is,
  outline: Ss,
  circle: As,
  bordered: Ds,
  tint: Ms,
  active: Ts,
  hoverBgOverride: Rs,
  gradient: zs
};
function Ol({
  icon: t,
  title: n,
  active: a = !1,
  size: o = "md",
  variant: s = "plain",
  onClick: c,
  onMouseDown: l,
  disabled: i = !1,
  color: r,
  hoverColor: _,
  bordered: m = !1,
  borderColor: d = "#e2e8f0",
  borderHoverColor: u = "#3b82f6",
  tint: b = !1,
  tintColor: f = "#eef4ff",
  tintHoverColor: h = "#dbeafe",
  hoverBackground: E,
  gradient: w
}) {
  const D = typeof o == "number", R = [
    Z.iconButton,
    D ? "" : Z[o],
    Z[s],
    a ? Z.active : "",
    m ? Z.bordered : "",
    b ? Z.tint : "",
    E !== void 0 ? Z.hoverBgOverride : "",
    w ? Z.gradient : ""
  ].filter(Boolean).join(" "), X = {
    ...D ? { width: o, height: o } : {},
    ...r !== void 0 ? { "--ax-icon-color": r } : {},
    ..._ !== void 0 ? { "--ax-icon-hover": _ } : {},
    ...m ? { "--ax-icon-border": d, "--ax-icon-border-hover": u } : {},
    ...b ? { "--ax-icon-tint": f, "--ax-icon-tint-hover": h } : {},
    ...E !== void 0 ? { "--ax-icon-hover-bg": E } : {},
    ...w ? { background: `linear-gradient(135deg, ${w[0]}, ${w[1]})` } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: R,
      style: X,
      onClick: c,
      onMouseDown: l,
      disabled: i,
      title: n,
      "aria-label": n
    },
    t
  );
}
const qs = "_wrapper_wrch3_1", Xs = "_searchIcon_wrch3_18", Ps = "_input_wrch3_26", Ws = "_clearButton_wrch3_40", Os = "_hint_wrch3_60", pe = {
  wrapper: qs,
  searchIcon: Xs,
  input: Ps,
  clearButton: Ws,
  hint: Os
}, Gs = /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ e.createElement("path", { d: "M21 21l-4.35-4.35" }));
function Gl({
  value: t,
  onChange: n,
  placeholder: a,
  hint: o,
  onSubmit: s,
  onClear: c
}) {
  const l = (i) => {
    i.key === "Enter" && (s == null || s());
  };
  return /* @__PURE__ */ e.createElement("div", { className: pe.wrapper }, /* @__PURE__ */ e.createElement("span", { className: pe.searchIcon }, Gs), /* @__PURE__ */ e.createElement(
    "input",
    {
      type: "text",
      className: pe.input,
      value: t,
      placeholder: a,
      onChange: (i) => n(i.target.value),
      onKeyDown: l
    }
  ), c && t.length > 0 && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: pe.clearButton,
      onClick: c,
      "aria-label": "clear"
    },
    /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6l12 12" }))
  ), o && /* @__PURE__ */ e.createElement("span", { className: pe.hint }, o));
}
const Ks = "_control_1kv40_1", Us = "_option_1kv40_10", Vs = "_active_1kv40_28", Hs = "_sm_1kv40_37", Js = "_md_1kv40_43", Zs = "_dot_1kv40_49", Ys = "_count_1kv40_56", Qs = "_outline_1kv40_70", ec = "_outlineOption_1kv40_75", K = {
  control: Ks,
  option: Us,
  active: Vs,
  sm: Hs,
  md: Js,
  dot: Zs,
  count: Ys,
  outline: Qs,
  outlineOption: ec
};
function Kl({
  options: t,
  value: n,
  onChange: a,
  size: o = "md",
  variant: s = "filled",
  activeBackground: c,
  activeColor: l,
  activeBorderColor: i
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [K.control, K[o], s === "outline" ? K.outline : ""].filter(Boolean).join(" "),
      role: "tablist"
    },
    t.map((r) => {
      const _ = r.value === n, m = _ ? {
        ...c !== void 0 ? { background: c } : {},
        ...l !== void 0 ? { color: l } : {},
        ...i !== void 0 ? { borderColor: i } : {}
      } : void 0;
      return /* @__PURE__ */ e.createElement(
        "button",
        {
          key: r.value,
          type: "button",
          role: "tab",
          "aria-selected": _,
          className: [K.option, _ ? K.active : "", s === "outline" ? K.outlineOption : ""].filter(Boolean).join(" "),
          style: m,
          onClick: () => a(r.value)
        },
        r.dot && /* @__PURE__ */ e.createElement("span", { className: K.dot, style: { backgroundColor: r.dot } }),
        /* @__PURE__ */ e.createElement("span", { className: K.label }, r.label),
        typeof r.count == "number" && /* @__PURE__ */ e.createElement("span", { className: K.count }, r.count)
      );
    })
  );
}
const tc = "_chip_8jgxm_1", nc = "_clickable_8jgxm_14", ac = "_suggested_8jgxm_23", oc = "_readonly_8jgxm_33", sc = "_plusIcon_8jgxm_39", cc = "_label_8jgxm_45", lc = "_removeButton_8jgxm_50", ae = {
  chip: tc,
  clickable: nc,
  default: "_default_8jgxm_18",
  suggested: ac,
  readonly: oc,
  plusIcon: sc,
  label: cc,
  removeButton: lc
};
function Ul({
  label: t,
  variant: n = "default",
  onRemove: a,
  onClick: o,
  background: s,
  textColor: c,
  borderColor: l
}) {
  const i = [ae.chip, ae[n], o ? ae.clickable : ""].filter(Boolean).join(" "), _ = s !== void 0 || c !== void 0 || l !== void 0 ? {
    ...s !== void 0 ? { background: s } : {},
    ...c !== void 0 ? { color: c } : {},
    ...l !== void 0 ? { borderColor: l } : {}
  } : {}, m = n !== "readonly" && !!a, d = /* @__PURE__ */ e.createElement(e.Fragment, null, n === "suggested" && /* @__PURE__ */ e.createElement("span", { className: ae.plusIcon, "aria-hidden": "true" }, "+"), /* @__PURE__ */ e.createElement("span", { className: ae.label }, t), m && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: ae.removeButton,
      "aria-label": `remove ${t}`,
      onClick: (u) => {
        u.stopPropagation(), a == null || a();
      }
    },
    /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6l12 12" }))
  ));
  return o ? /* @__PURE__ */ e.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: i,
      style: _,
      onClick: o,
      onKeyDown: (u) => {
        (u.key === "Enter" || u.key === " ") && (u.preventDefault(), o());
      }
    },
    d
  ) : /* @__PURE__ */ e.createElement("span", { className: i, style: _ }, d);
}
const rc = "_wrapper_15dm4_1", ic = "_disabled_15dm4_8", _c = "_track_15dm4_13", dc = "_checked_15dm4_30", mc = "_thumb_15dm4_34", uc = "_label_15dm4_50", oe = {
  wrapper: rc,
  disabled: ic,
  track: _c,
  checked: dc,
  thumb: mc,
  label: uc
};
function Vl({
  checked: t,
  onChange: n,
  labelOn: a,
  labelOff: o,
  disabled: s = !1,
  color: c
}) {
  const l = t ? a : o;
  return /* @__PURE__ */ e.createElement("label", { className: [oe.wrapper, s ? oe.disabled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": t,
      disabled: s,
      className: [oe.track, t ? oe.checked : ""].filter(Boolean).join(" "),
      style: t && c !== void 0 ? { background: c } : void 0,
      onClick: () => !s && n(!t)
    },
    /* @__PURE__ */ e.createElement("span", { className: oe.thumb })
  ), l && /* @__PURE__ */ e.createElement("span", { className: oe.label }, l));
}
const pc = "_card_1uh3t_1", hc = "_active_1uh3t_24", bc = "_iconChip_1uh3t_29", gc = "_body_1uh3t_41", fc = "_label_1uh3t_48", yc = "_description_1uh3t_54", se = {
  card: pc,
  active: hc,
  iconChip: bc,
  body: gc,
  label: fc,
  description: yc
};
function Hl(t) {
  const { icon: n, label: a, description: o, active: s = !1, onClick: c } = t;
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${se.card} ${s ? se.active : ""}`,
      onClick: c,
      "aria-pressed": s
    },
    /* @__PURE__ */ e.createElement("span", { className: se.iconChip }, n),
    /* @__PURE__ */ e.createElement("span", { className: se.body }, /* @__PURE__ */ e.createElement("span", { className: se.label }, a), o && /* @__PURE__ */ e.createElement("span", { className: se.description }, o))
  );
}
const Ec = "_breadcrumb_zkol9_1", vc = "_list_zkol9_6", kc = "_item_zkol9_16", Nc = "_link_zkol9_22", $c = "_plain_zkol9_43", wc = "_current_zkol9_48", xc = "_separator_zkol9_54", ee = {
  breadcrumb: Ec,
  list: vc,
  item: kc,
  link: Nc,
  plain: $c,
  current: wc,
  separator: xc
};
function Jl(t) {
  const { items: n, separator: a = "/", textColor: o, hoverColor: s, currentColor: c } = t, l = {
    ...o !== void 0 ? { "--ax-bc-text": o } : {},
    ...s !== void 0 ? { "--ax-bc-hover": s } : {},
    ...c !== void 0 ? { "--ax-bc-current": c } : {}
  };
  return /* @__PURE__ */ e.createElement("nav", { className: ee.breadcrumb, "aria-label": "breadcrumb", style: l }, /* @__PURE__ */ e.createElement("ol", { className: ee.list }, n.map((i, r) => {
    const _ = r === n.length - 1;
    return /* @__PURE__ */ e.createElement("li", { key: r, className: ee.item }, _ ? /* @__PURE__ */ e.createElement("span", { className: ee.current, "aria-current": "page" }, i.label) : i.onClick ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: ee.link,
        onClick: i.onClick
      },
      i.label
    ) : /* @__PURE__ */ e.createElement("span", { className: ee.plain }, i.label), !_ && /* @__PURE__ */ e.createElement("span", { className: ee.separator, "aria-hidden": "true" }, a));
  })));
}
const jc = "_treeItem_1ouqz_1", Fc = "_active_1ouqz_18", Bc = "_chevron_1ouqz_28", Cc = "_chevronExpanded_1ouqz_48", Lc = "_chevronSpacer_1ouqz_52", Ic = "_icon_1ouqz_57", Sc = "_label_1ouqz_69", Ac = "_count_1ouqz_76", Dc = "_dark_1ouqz_86", U = {
  treeItem: jc,
  active: Fc,
  chevron: Bc,
  chevronExpanded: Cc,
  chevronSpacer: Lc,
  icon: Ic,
  label: Sc,
  count: Ac,
  dark: Dc
};
function Zl(t) {
  const {
    icon: n,
    label: a,
    count: o,
    indent: s = 0,
    active: c = !1,
    expandable: l = !1,
    expanded: i = !1,
    theme: r = "light",
    onToggleExpand: _,
    onClick: m
  } = t, d = (b) => {
    b.stopPropagation(), _ == null || _();
  }, u = r === "dark" ? U.dark : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${U.treeItem} ${u} ${c ? U.active : ""}`,
      style: { paddingLeft: 12 + s * 16 },
      onClick: m,
      role: "treeitem",
      "aria-selected": c,
      "aria-expanded": l ? i : void 0
    },
    l ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: `${U.chevron} ${i ? U.chevronExpanded : ""}`,
        onClick: d,
        "aria-label": i ? "Collapse" : "Expand"
      },
      /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3 1.5L7 5L3 8.5",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ))
    ) : /* @__PURE__ */ e.createElement("span", { className: U.chevronSpacer }),
    n && /* @__PURE__ */ e.createElement("span", { className: U.icon }, n),
    /* @__PURE__ */ e.createElement("span", { className: U.label }, a),
    typeof o == "number" && /* @__PURE__ */ e.createElement("span", { className: U.count }, o)
  );
}
const Mc = "_backdrop_gstyy_1", Tc = "_panel_gstyy_9", Rc = "_right_gstyy_21", zc = "_left_gstyy_27", qc = "_header_gstyy_51", Xc = "_icon_gstyy_59", Pc = "_titleGroup_gstyy_66", Wc = "_kicker_gstyy_71", Oc = "_title_gstyy_66", Gc = "_subtitle_gstyy_87", Kc = "_closeButton_gstyy_93", Uc = "_body_gstyy_115", Vc = "_footer_gstyy_123", I = {
  backdrop: Mc,
  panel: Tc,
  right: Rc,
  left: zc,
  header: qc,
  icon: Xc,
  titleGroup: Pc,
  kicker: Wc,
  title: Oc,
  subtitle: Gc,
  closeButton: Kc,
  body: Uc,
  footer: Vc
};
function Yl({
  open: t,
  onClose: n,
  icon: a,
  kicker: o,
  title: s,
  titleSize: c,
  titleWeight: l,
  subtitle: i,
  footer: r,
  children: _,
  side: m = "right",
  headerBackground: d,
  topOffset: u
}) {
  if (!t)
    return null;
  const b = [I.panel, m === "left" ? I.left : I.right].filter(Boolean).join(" "), f = {
    ...c !== void 0 ? { fontSize: c } : {},
    ...l !== void 0 ? { fontWeight: l } : {}
  }, h = u !== void 0 ? { top: u, height: `calc(100vh - ${u}px)` } : void 0;
  return /* @__PURE__ */ e.createElement("div", { className: I.backdrop, onClick: n }, /* @__PURE__ */ e.createElement("div", { className: b, style: h, onClick: (E) => E.stopPropagation() }, /* @__PURE__ */ e.createElement("div", { className: I.header, style: d !== void 0 ? { background: d } : void 0 }, a && /* @__PURE__ */ e.createElement("span", { className: I.icon }, a), /* @__PURE__ */ e.createElement("div", { className: I.titleGroup }, o && /* @__PURE__ */ e.createElement("p", { className: I.kicker }, o), /* @__PURE__ */ e.createElement("h2", { className: I.title, style: f }, s), i && /* @__PURE__ */ e.createElement("p", { className: I.subtitle }, i)), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: I.closeButton,
      onClick: n,
      "aria-label": "닫기"
    },
    "×"
  )), /* @__PURE__ */ e.createElement("div", { className: I.body }, _), r && /* @__PURE__ */ e.createElement("div", { className: I.footer }, r)));
}
const Hc = "_backdrop_6kso7_1", Jc = "_menu_6kso7_8", Zc = "_alignRight_6kso7_24", Yc = "_alignLeft_6kso7_28", Qc = "_item_6kso7_32", el = "_itemIcon_6kso7_50", tl = "_itemText_6kso7_59", nl = "_itemLabel_6kso7_66", al = "_itemDescription_6kso7_72", ol = "_danger_6kso7_77", z = {
  backdrop: Hc,
  menu: Jc,
  alignRight: Zc,
  alignLeft: Yc,
  item: Qc,
  itemIcon: el,
  itemText: tl,
  itemLabel: nl,
  itemDescription: al,
  danger: ol
};
function Ql({
  open: t,
  onClose: n,
  items: a,
  anchor: o = "right"
}) {
  if (!t)
    return null;
  const s = [z.menu, o === "left" ? z.alignLeft : z.alignRight].filter(Boolean).join(" "), c = (l) => {
    l.onClick(), n();
  };
  return /* @__PURE__ */ e.createElement(Ue, null, /* @__PURE__ */ e.createElement("div", { className: z.backdrop, onClick: n }), /* @__PURE__ */ e.createElement("div", { className: s, onClick: (l) => l.stopPropagation() }, a.map((l, i) => {
    const r = [z.item, l.danger ? z.danger : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        key: i,
        type: "button",
        className: r,
        onClick: () => c(l)
      },
      l.icon && /* @__PURE__ */ e.createElement("span", { className: z.itemIcon }, l.icon),
      /* @__PURE__ */ e.createElement("span", { className: z.itemText }, /* @__PURE__ */ e.createElement("span", { className: z.itemLabel }, l.label), l.description && /* @__PURE__ */ e.createElement("span", { className: z.itemDescription }, l.description))
    );
  })));
}
const sl = "_backdrop_3pc9i_1", cl = "_card_3pc9i_12", ll = "_header_3pc9i_23", rl = "_icon_3pc9i_31", il = "_titleGroup_3pc9i_38", _l = "_title_3pc9i_38", dl = "_subtitle_3pc9i_50", ml = "_closeButton_3pc9i_56", ul = "_body_3pc9i_78", pl = "_footer_3pc9i_85", q = {
  backdrop: sl,
  card: cl,
  header: ll,
  icon: rl,
  titleGroup: il,
  title: _l,
  subtitle: dl,
  closeButton: ml,
  body: ul,
  footer: pl
};
function er({
  open: t,
  onClose: n,
  icon: a,
  title: o,
  subtitle: s,
  footer: c,
  width: l = 480,
  children: i
}) {
  if (!t)
    return null;
  const r = typeof l == "number" ? `${l}px` : l;
  return /* @__PURE__ */ e.createElement("div", { className: q.backdrop, onClick: n }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: q.card,
      style: { width: r },
      onClick: (_) => _.stopPropagation()
    },
    /* @__PURE__ */ e.createElement("div", { className: q.header }, a && /* @__PURE__ */ e.createElement("span", { className: q.icon }, a), /* @__PURE__ */ e.createElement("div", { className: q.titleGroup }, /* @__PURE__ */ e.createElement("h2", { className: q.title }, o), s && /* @__PURE__ */ e.createElement("p", { className: q.subtitle }, s)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: q.closeButton,
        onClick: n,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: q.body }, i),
    c && /* @__PURE__ */ e.createElement("div", { className: q.footer }, c)
  ));
}
export {
  Hl as AXActionCard,
  wl as AXAiIconBadge,
  Dl as AXAiSuggestionBanner,
  Ke as AXAvatar,
  xl as AXAvatarStack,
  jl as AXBadge,
  Jl as AXBreadcrumb,
  Wl as AXButton,
  kl as AXCardPanel,
  Fl as AXCommentRow,
  El as AXCommentThread,
  Xl as AXDataTable,
  Nl as AXDivider,
  Yl as AXDrawer,
  Ql as AXDropdownMenu,
  Ml as AXEmptyState,
  Tl as AXExpandableSummary,
  Bl as AXFileChip,
  Gn as AXFileTypeIcon,
  Ol as AXIconButton,
  Pl as AXKeyValueGrid,
  Cl as AXKeyValueRow,
  Ll as AXListRow,
  er as AXModal,
  $l as AXPanelHeader,
  Il as AXPersonRow,
  Rl as AXProgressBar,
  Sl as AXRankingRow,
  Gl as AXSearchInput,
  Kl as AXSegmentedControl,
  Al as AXStatusBadge,
  zl as AXStepProgress,
  Ul as AXTagChip,
  Vl as AXToggleSwitch,
  Zl as AXTreeItem,
  ql as AXTypingDots,
  Xe as GW_ORIGIN,
  fe as REFRESH_KEY,
  xe as SESSION_EXPIRED_EVENT,
  Ce as TOKEN_KEY,
  ye as authorizedFetch,
  Ze as clearTokens,
  bl as colors,
  gl as configureAuth,
  yl as configureComments,
  Le as decodeClaims,
  nt as getFreshToken,
  He as getStoredToken,
  Ve as isExpired,
  We as isRefreshExpired,
  at as isReply,
  he as notifySessionExpired,
  fl as onSessionExpired,
  Ge as refreshTokens,
  Je as saveTokens,
  Qe as startRefreshExpiryWatch,
  Oe as stopRefreshExpiryWatch,
  vl as useCommentCounts,
  it as useComments
};
